/**
 * Created by AlexanderC on 5/25/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorResponse = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Response2 = require('./Response');

var _Exception = require('../../Exception/Exception');

var _Helper = require('../../HTTP/Helper');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Error response sent to the lambda context
 */
let ErrorResponse = exports.ErrorResponse = function (_Response) {
  _inherits(ErrorResponse, _Response);

  /**
   * @param {Runtime} runtime
   * @param {Error|String|*} error
   */
  function ErrorResponse(runtime, error) {
    _classCallCheck(this, ErrorResponse);

    return _possibleConstructorReturn(this, (ErrorResponse.__proto__ || Object.getPrototypeOf(ErrorResponse)).call(this, runtime, ErrorResponse.createErrorObject(error)));
  }

  /**
   * @param {Error|String|*} error
   * @returns {Object}
   */


  _createClass(ErrorResponse, [{
    key: 'data',


    /**
     *
     * @returns {Object}
     * @private
     */
    get: function get() {
      return JSON.stringify(this._data);
    }

    /**
     * @returns {String}
     */

  }], [{
    key: 'createErrorObject',
    value: function createErrorObject(error) {
      let errorObj = {};
      let errorCode = _Exception.Exception.DEFAULT_CODE;

      if (error.name === 'ValidationError') {
        // we assume it's a joi validation error
        errorCode = 400;
        errorObj = {
          errorType: error.name,
          errorMessage: typeof error.annotate === 'function' ? error.annotate() : error.message,
          errorStack: error.stack || new Error(error.message).stack,
          validationErrors: error.details
        };
      } else if (error instanceof Error) {
        errorObj = {
          errorType: error.name,
          errorMessage: error.message,
          errorStack: error.stack || new Error(error.message).stack
        };
      } else {
        let plainError = (error || 'Unexpected error occurred.').toString();

        errorObj = {
          errorType: 'Error',
          errorMessage: plainError,
          errorStack: new Error(plainError).stack
        };
      }

      errorObj[_Exception.Exception.CODE_KEY] = _Helper.Helper.assureDefinedCode(error.code || errorCode);

      return errorObj;
    }
  }, {
    key: 'contextMethod',
    get: function get() {
      return 'fail';
    }
  }]);

  return ErrorResponse;
}(_Response2.Response);


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/Lambda/ErrorResponse.js
// module id = 361
// module chunks = 0